export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_08-ed2342c818497fb0d84f36ca6c412b7d.png";